module.exports = __webpack_public_path__ + "img/7.7a7de137.jpg";